// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_mainDialog__pBu7V {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 320px;
}
.info_mainDialog__pBu7V .info_header__LVK7B {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.info_mainDialog__pBu7V .info_footer__TQssu {
  display: flex;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/InfoDialog/info.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACR;AAEI;EACI,aAAA;EACA,SAAA;AAAR","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 320px;\n\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .footer {\n        display: flex;\n        gap: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDialog": `info_mainDialog__pBu7V`,
	"header": `info_header__LVK7B`,
	"footer": `info_footer__TQssu`
};
export default ___CSS_LOADER_EXPORT___;
